import { render, staticRenderFns } from "./Oportunidad.vue?vue&type=template&id=41f047bd&"
import script from "./Oportunidad.vue?vue&type=script&lang=js&"
export * from "./Oportunidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports